<template>
  <v-dialog  transition="dialog-bottom-transition"  max-width="400"   v-model="dialogdeposit"  content-class="depositmodal" @click:outside="closeDialog">
    <v-card class="rounded-xl">
      <v-card-text >
        <div class="popupbody">
          <div class="row">
            <div class="heading col-md-10 col-xs-10">Deposit</div>
            <div class="closebtn cursor col-md-2 col-xs-2">
               <span class="material-icons closeicon"  @click="closeDialog">close</span>
            </div>
          </div> 
          <div v-if="depositscreenfirst">
            <div class="totalamnt text-center">
              <div class="headfirst">Total Balance</div>
              <div class="amntdiv mt-5 myflex"><div>${{depositprice}}</div></div>
            </div>
            <div class="pricerange mt-5 pb-5">
               <v-slider step="1" min="1" max="10000" disabled track-color="white" tick-size=30 color="themebtn" v-model="depositprice"></v-slider>
            </div> 
            <div class="pricebtns">
              <div class="prices" @click="changeprice(1)" :class="{'active':depositprice == 1  }"><div class="pricesymbol">$1</div></div>
              <div class="prices" @click="changeprice(10)" :class="{'active':depositprice == 10  }"><div class="pricesymbol">$10</div></div>
              <div class="prices" @click="changeprice(50)" :class="{'active':depositprice == 50  }"><div class="pricesymbol">$50</div></div>
              <div class="prices" @click="changeprice(100)" :class="{'active':depositprice == 100  }"><div class="pricesymbol">$100</div></div>
              <div class="prices" @click="changeprice(500)" :class="{'active':depositprice == 500  }"><div class="pricesymbol">$500</div></div>
              <div class="prices" @click="changeprice(1000)" :class="{'active':depositprice == 1000  }"><div class="pricesymbol">$1000</div></div>
            </div>
            <div class="text-center mt-10"><v-text-field label="Add Balance" v-model="depositprice" type="number" outlined></v-text-field></div>
          </div> 
        </div>
        <div v-if="!depositscreenfirst">
          <div class="text-left"><a @click="depoback"><span class="material-icons">arrow_back</span></a></div>
          <div class="totalbalance"  v-bind:style="{ 'background-image': 'url(' + depostieback + ')' }">
             <div class="inneramt">
               <div class="leftside">Pack</div>
               <div class="rightside myflex"><div>${{depositprice}}</div></div>
             </div>
          </div>
          <div class="totalbalance  mt-3"  v-bind:style="{ 'background-image': 'url(' + depostieback + ')' }">
            <div class="inneramt">
               <div class="leftside">Paypal Fee</div>
               <div class="rightside myflex"><div>${{ getprentage(depositprice) }}</div></div>
            </div>
          </div>
          <div class="totalbalance mt-3"  v-bind:style="{ 'background-image': 'url(' + depostieback + ')' }">
            <div class="inneramt">
              <div class="leftside">Total</div>
              <div class="rightside myflex"><div>${{gettotalvalue(depositprice)}}</div></div>
            </div>
          </div> 
        </div>
        <div v-if="error" class="red--text smallfonts">{{ errorText }}</div>
      </v-card-text>
      <v-card-actions class="justify-center action pb-5">
        <v-btn x-large class="primary" :disabled="makedisable" v-if="depositscreenfirst" @click="nextdepositscreen">Next</v-btn>
        <div v-else id="paypal-button"></div>
      </v-card-actions>
    </v-card>
   </v-dialog>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import LoadScript from 'vue-plugin-load-script';

Vue.use(LoadScript);

Vue.use(VueAxios, axios)
export default {
  props:{
    dialogdeposit:Boolean
  } , 
  data(){
    return{
        depositscreenfirst:true,
        error :'',
        errorText:'',
        makedisable:false,
        depositprice:12,
        depostieback:require("@/assets/depositeback.png"),
    }
  },
  
  methods:{
      gettotalvalue(price){
         var mainval   = price;
         var percent   = 0;
         var paypalfee = 2;//this.$store.getters.getcurrencySetting.paypal_fee;
         
         if(paypalfee > 0)
         {
           percent = (price/100)*paypalfee;
         }
         mainval = (parseFloat(percent)+parseFloat(mainval)).toFixed(2);
         
         this.finaldeposite = mainval;

         return mainval;
    },
    getprentage(price)
    { 
         var mainval   = 0;
         var paypalfee = 2;//this.$store.getters.getcurrencySetting.paypal_fee;
         
         if(paypalfee > 0)
         {
           mainval = (price/100)*paypalfee;
         }

         return mainval.toFixed(2);
    },
    depoback(){
      this.depositscreenfirst = true;
    },
    closeDialog(){
     // this.dialogdeposit = false
      this.$emit('update:dialogdeposit', false);
      this.depositscreenfirst = true;
    },
    changeprice(price){
      this.depositprice = price;
      localStorage.setItem('price', price);
    },
    nextdepositscreen(){
      this.depositscreenfirst = false;
      this.makedisable = false;
      /*this.$store.dispatch("getpaymentToken",{"amount":this.depositprice}).then((response) => {
         this.referenceno = response.data.data.reference;
      });*/
       var mythis = this;
       this.$loadScript("https://www.paypalobjects.com/api/checkout.js").then(() => 
     {
       window.paypal.Button.render({
         //env: 'sandbox',
         client: {
          //sandbox: 'AahbGLhQaqpJYUJzpz1LbnjExJJZOqiQcKTyuyElhY64yHk1WRiEWEZJlPjX-b8dMh7mcrNnVdTwsbaa',
          production: 'AUxJGrr53OY24x1KlUwTHy4rkPvhW_Srkli1rmnRjfHyDTa00ZEgphHVJ0wkdVnWxA43KeMrPCVS39re'
         },
         locale: 'en_US',
         style: {
                  size: 'small',
                  color: 'gold',
                  shape: 'pill',
                  tagline: 'false'
                },
         commit: true,

         payment: function(resolve, reject) {
           console.log(resolve, reject);
          let returnUrl = "https://admin.sporttrade.online/faq";
          let amount = mythis.finaldeposite;

           return new Promise((resolve, reject) => {
           axios.post('create-payment', {
            return_url: returnUrl,
            amount:amount,
        }, {
                headers: { 'Authorization': 'Bearer ' + localStorage.getItem('access_token') }
            })
            .then(res => {
              //console.log(res.data);
                localStorage.setItem('reference_id', res.data.paypal_intent_id.reference_id);
                resolve(res.data.paypal_intent_id.paypal_intent_id)
            })
            .catch(error => {
                reject(error)
            })
    })
    },
    
    onAuthorize: function(data) {
      
          return new Promise((resolve, reject) => {
        axios.post('execute-payment',  {
            payer_id: data.payerID,
            payment_id: data.paymentID,
            app_type:process.env.VUE_APP_TYPE,
            reference_id:localStorage.getItem('reference_id')
        }, {
                headers: { 'Authorization': 'Bearer ' +  localStorage.getItem('access_token') }
            })
            .then(res => {
              localStorage.removeItem('reference_id');
              localStorage.removeItem('price');
              mythis.closeDialog();
              mythis.$store.dispatch('retrieveBalance');
                resolve(res)
            })
            .catch(error => {
                reject(error)
            })
    })
    }
  }, '#paypal-button');
     });
    },
  }     
}
</script>
<style scoped>
.pricerange::v-deep .v-application .primary.lighten-3{background-color:none;}
.pricerange::v-deep .v-slider--horizontal .v-slider__track-container{height:6px;}
.pricerange::v-deep .v-slider__thumb{height:20px; width:20px;background: white !important;background-color: white;border: 4px solid #247cdd;}
.pricebtns {display: flex;cursor:pointer;justify-content: space-between;}
.prices {background: white;border-radius: 10px;flex: 0 23%;margin-left: 1%;padding: 15px 0;}
.prices.active {background: #247CDD;border-radius: 10px;flex: 0 23%;margin-left: 1%;padding: 15px 0;}
.pricesymbol{font-size: 18px;background: white;margin: auto;padding: 10px 20px;border-radius: 10px;width:65%;color: #767676;}
.pricevalue {color: white;text-align: center;padding: 10px 0 0;font-size: 16px;color: #767676;}
.active .pricesymbol {color:#247cdd;}
.active .pricevalue {color: white;}
.popupbody { padding-top: 15px; padding-bottom: 10px;}
.prices .pricesymbol {	font-size: 15px;background: white;	margin: auto;padding: 0px 2px;border-radius: 4px;width: 95%;color: #767676;	text-align: center;}
.prices .pricevalue > div{font-size:14px;}
.prices .pricevalue{padding-top:0px;}
.theme--light.v-slider .v-slider__track-fill {
    background: #247cdd !important;
}
.popupbody .heading {
    font-size: 18px;
    font-weight: 500;
    color: #010101;
    line-height: 35px;
}
.headfirst[data-v-25047ed8] {
    color: #767676;
    font-size: 16px;
    font-weight: 400;
}
.amntdiv {
    font-size: 22px;
    color: #010101;
    font-weight: 400;
    line-height: 27.5px;
}
.totalbalance {background-size: 100% 100%;background-repeat: no-repeat;}
.inneramt{display: flex;justify-content: space-between;padding: 15px 15px;color: white;font-size: 15px;font-weight: 400;}
.name-title {text-transform: capitalize;}

</style>